

















































import { Component, Mixins } from "vue-property-decorator";
import { DocumentViewMixin } from "./mixins";
import { DebugTool } from "../developer/document/viewer";
import {
  PatientSpecifiedHeaderPane,
  RightSidePane,
  ContentHeaderPane,
  NavigationPane,
} from "../panes";
import ExistingDocumentViewer from "./viewers/ExistingDocumentViewer.vue";
import DocumentViewerMenu from "./viewers/contents/DocumentViewerMenu.vue";
import DocumentArchiveSelector from "./selectors/DocumentArchiveSelector.vue";
import DocumentArchiveIndicator from "./selectors/DocumentArchiveIndicator.vue";
import DocumentReferenceFileSelector from "./selectors/DocumentReferenceFileSelector.vue";
import PatientExternalMenu from "./viewers/menus/PatientExternalMenu.vue";
import { IExternalMenuItemConfiguration } from "../../domain/configuration";

@Component({
  components: {
    PatientSpecifiedHeaderPane,
    RightSidePane,
    ContentHeaderPane,
    NavigationPane,
    selector: DocumentArchiveSelector,
    DocumentViewerMenu,
    indicator: DocumentArchiveIndicator,
    ExistingDocumentViewer,
    referenceFileSelector: DocumentReferenceFileSelector,
    DebugTool,
    PatientExternalMenu,
  },
})
export default class DocumentView extends Mixins(DocumentViewMixin) {
  $refs!: {
    archiveSelector: DocumentArchiveSelector
  };
  
  get externalMenuItems(): IExternalMenuItemConfiguration[] {
    return this.$configuration.behavior.document.viewer.externalMenus;
  }

  onDocumentNoteRegistered(): void {
    this.$refs.archiveSelector.updateArchiveDocuments(this.selectedArchiveId);
  }
}
